var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99878 17.4605V20.5005C2.99878 20.7805 3.21878 21.0005 3.49878 21.0005H6.53878C6.66878 21.0005 6.79878 20.9505 6.88878 20.8505L17.8088 9.94055L14.0588 6.19055L3.14878 17.1005C3.04878 17.2005 2.99878 17.3205 2.99878 17.4605ZM20.7088 7.04055C21.0988 6.65055 21.0988 6.02055 20.7088 5.63055L18.3688 3.29055C17.9788 2.90055 17.3488 2.90055 16.9588 3.29055L15.1288 5.12055L18.8788 8.87055L20.7088 7.04055Z",
    fill: "black"
  })));
};
var Memo = /*#__PURE__*/memo(SvgEdit);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/edit.d46b12764a1d9d7b2c5b87468e4e1998.svg";